import React, { useState, useEffect } from 'react';
import { Container, Navbar, NavLink } from 'reactstrap';
import { axios } from '../../services/ServiceUtils';
import { FooterBox, NavItem, Nav, UnorderedList } from './styles';
import LanguageSelector from '../LanguageSelector';
import { useConfigContext } from '../../contexts/ConfigContext';

const FooterPilot = ({ language }) => {
  const [data, setData] = useState({ footerLinks: [], footerText: '' });
  const { TOGGLE, allowedHeaders } = useConfigContext();

  useEffect(() => {
    axios
      .get('api/footer', {
        headers: {
          'Content-Language': `${language.locale}`,
        },
      })
      .then((result) => {
        setData(result.data)
      })
      .catch(e => {
        // eslint-disable-next-line
        console.error('request error', e);
      });
  }, [language]);

  return (
    <>
      <FooterBox>
        <Navbar aria-label="footer" dark expand="md" className="mx-3 mx-xl-auto p-0">
          <Container className="py-2 flex-column flex-sm-row justify-content-between mx-xl-auto">
            <Nav className="mr-aut navbar-nav">
              <UnorderedList>
                {allowedHeaders?.includes(language?.locale?.toLowerCase()) && data.footerLinks
                  ? data.footerLinks.map(link => {
                      let target = link.parameters
                        ? link.parameters
                            .split('target="')
                            .pop()
                            .split('"')[0]
                        : '_self';
                      let targetClass = link.parameters
                        ? link.parameters
                            .split('class="')
                            .pop()
                            .split('"')[0]
                        : '';
                    return (
                          <NavItem key={link.title} className="nav-item">
                            <NavLink
                              target={target}
                              href={link.url}
                              className={`text-white py-2 ${targetClass}`}
                            >
                              {link.title}
                            </NavLink>
                          </NavItem>
                      );
                    })
                  : ''}
              </UnorderedList>
            </Nav>
            <Nav className="ml-auto navbar-nav">
              <UnorderedList>
                <NavItem className="py-2 pr-3 py-sm-0 text-md-right flex-fill">
                  {/* TODO: this field should be returned from Content Studio eventually */}© 2023
                  Dell Financial Services
                </NavItem>
              </UnorderedList>
            </Nav>
            {TOGGLE.toggleLanguageSelector && (
              <Nav className="navbar-nav language-selector-container">
                <UnorderedList>
                  <NavItem className="py-2 pr-3 py-sm-0 d-flex">
                    <LanguageSelector isFooter />
                  </NavItem>
                </UnorderedList>
              </Nav>
            )}
          </Container>
        </Navbar>
      </FooterBox>
    </>
  );
};

export default FooterPilot;
